<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 13.4375C1.75 14.1758 2.32422 14.75 3.0625 14.75H10.9375C11.6484 14.75 12.25 14.1758 12.25 13.4375V4.25H1.75V13.4375ZM9.1875 6.4375C9.1875 6.21875 9.37891 6 9.625 6C9.84375 6 10.0625 6.21875 10.0625 6.4375V12.5625C10.0625 12.8086 9.84375 13 9.625 13C9.37891 13 9.1875 12.8086 9.1875 12.5625V6.4375ZM6.5625 6.4375C6.5625 6.21875 6.75391 6 7 6C7.21875 6 7.4375 6.21875 7.4375 6.4375V12.5625C7.4375 12.8086 7.21875 13 7 13C6.75391 13 6.5625 12.8086 6.5625 12.5625V6.4375ZM3.9375 6.4375C3.9375 6.21875 4.12891 6 4.375 6C4.59375 6 4.8125 6.21875 4.8125 6.4375V12.5625C4.8125 12.8086 4.59375 13 4.375 13C4.12891 13 3.9375 12.8086 3.9375 12.5625V6.4375ZM12.6875 1.625H9.625L9.29688 0.996094C9.21484 0.859375 9.07812 0.75 8.91406 0.75H5.05859C4.89453 0.75 4.75781 0.859375 4.67578 0.996094L4.375 1.625H1.3125C1.06641 1.625 0.875 1.84375 0.875 2.0625V2.9375C0.875 3.18359 1.06641 3.375 1.3125 3.375H12.6875C12.9062 3.375 13.125 3.18359 13.125 2.9375V2.0625C13.125 1.84375 12.9062 1.625 12.6875 1.625Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
  import { defineProps } from 'vue';

  const props = defineProps({
    fill: {
      type: String,
      default: 'black',
    },
  });
</script>
